<template>
  <div class="page">
    <PageHeader>
      Учет <i v-if="loading" class="el-icon-loading"></i>
    </PageHeader>
    <div class="content" v-if="loaded">
      <el-card
        shadow="always"
        :body-style="{ padding: '20px' }"
        v-loading="loading"
      >
        <div slot="header">
          <span>Новая операция</span>
        </div>
        <!-- card body -->
        <el-form ref="form" :model="form" label-width="135px">
          <div>
            <el-form-item
              label="Открыта"
              prop="dateStart"
              :rules="validation.dateStart.rules"
            >
              <el-col :span="11">
                <el-date-picker
                  type="datetime"
                  placeholder="Pick a date"
                  v-model="form.dateStart"
                  style="width: 100%;"
                ></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item
              label="Клиент"
              prop="userName"
              :rules="validation.userName.rules"
            >
              <input
                type="text"
                class="el-input__inner"
                v-model="form.userName"
                readonly="readonly"
              />
            </el-form-item>
            <el-form-item
              label="Тип"
              prop="sourceType"
              :rules="validation.sourceType.rules"
            >
              <input
                type="text"
                class="el-input__inner"
                v-model="form.sourceType"
                readonly="readonly"
              />
            </el-form-item>
            <el-form-item
              label="Проект"
              prop="sourceChannel"
              :rules="validation.sourceChannel.rules"
            >
              <input
                type="text"
                class="el-input__inner"
                v-model="form.sourceChannel"
                readonly="readonly"
              />
            </el-form-item>
            <div class="block el-card is-always-shadow" :class="getStatusCss(transaction.status)">
              <div class="header">
                <div class="title" style="float: right;">
                  {{ getStatusText(transaction.status) }}
                </div>
                <div class="title">
                  ID: {{ transaction._id }}
                </div>
              </div>

              <div class="content">
                <div class="block-left">
                  <h4>Покупаем:</h4>
                  <hr />
                  <p>
                    <b>Валюта:</b>
                    {{ transaction.give.valute ? transaction.give.valute.title : "" }}
                  </p>
                  <p>
                    <b>Курс:</b> {{ transaction.give.valute.course }}
                    {{ transaction.give.valute.key }}
                  </p>
                  <p>
                    <b>Комиссия:</b>
                    {{ 100 - +transaction.give.valute.percentGive * 100 }}%
                  </p>
                  <br />
                  <hr />
                  <p><b>Формы:</b></p>
                  <ul style="margin-left: 20px">
                    <li v-for="form in transaction.give.forms" v-if="form && form.title === 'Количество'" :key="form.key">
                      {{ form ? form.title : "" }}: {{ form.value }}
                    </li>
                  </ul>
                </div>
                <div class="block-right">
                  <h4>Продаем:</h4>
                  <hr />
                  <p>
                    <b>Валюта:</b>
                    {{ transaction.get.valute ? transaction.get.valute.title : "" }}
                  </p>
                  <p>
                    <b>Курс:</b> {{ transaction.get.valute.course }}
                    {{ transaction.get.valute.key }}
                  </p>
                  <p>
                    <b>Комиссия:</b>
                    {{ +parseFloat(transaction.get.valute.percentGet) * 100 - 100 }}%
                  </p>
                  <br />
                  <hr />
                  <p><b>Формы:</b></p>
                  <ul style="margin-left: 20px">
                    <li v-for="form in transaction.get.forms" v-if="form && form.title === 'Количество'" :key="form.key">
                      {{ form ? form.title : "" }}: {{ form.value }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <el-form-item label="Комментарий" prop="comment">
              <el-input
                type="textarea"
                placeholder="Введите комментарий"
                v-model="form.comment"
                maxlength="150"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="Курсы"
            >
              <div v-if="!canGetRate.status">
                Курс не может быть получен. {{ canGetRate.message }}
              </div>
              <div v-else>
                <el-form-item
                  label-width="170px"
                  label="Курс биржевой"
                  size="normal"
                >
                  {{ numToString(rate.outinRate) }}
                  {{ rate.incode }} за 1 {{ rate.outcode }} |
                  {{ numToString(rate.inoutRate) }}
                  {{ rate.outcode }} за 1
                  {{ rate.incode }}
                  <span
                    >(получен
                    {{ $dayjs(rate.rateDate).format("DD.MM.YYYY HH:mm:ss") }})
                  </span>
                </el-form-item>
                <el-form-item
                  label-width="170px"
                  label="Курс сделки"
                  size="normal"
                >
                  <span v-if="rateInternal.status">
                    {{ numToString(rateInternal.outinRate) }}
                    {{ rate.incode }} за 1 {{ rate.outcode }} |
                    {{ numToString(rateInternal.inoutRate) }}
                    {{ rate.outcode }} за 1 {{ rate.incode }}
                  </span>
                  <span v-else>
                    {{ rateInternal.message }}
                    <el-button
                      v-if="hasAtleastOneAmount"
                      type="text"
                      @click="openManualPrompt('rateInternalManual')()"
                      >Установить курс сделки вручную</el-button
                    >
                  </span>
                </el-form-item>
                <el-form-item
                  label-width="170px"
                  label="Разница монетарная"
                  size="normal"
                >
                  <span v-if="rateInternal.status">
                    {{
                      numToString(
                        rateInternal.inamount / rate.outinRate -
                          rateInternal.inamount / rateInternal.outinRate,
                        5
                      )
                    }}
                    {{ rate.outcode }}
                    |
                    {{
                      numToString(
                        (rateInternal.inamount / rate.outinRate -
                          rateInternal.inamount / rateInternal.outinRate) *
                          rate.outRateRub,
                        2
                      )
                    }}
                    RUB |
                    {{
                      numToString(
                        (rateInternal.inamount / rate.outinRate -
                          rateInternal.inamount / rateInternal.outinRate) *
                          rate.outRateUsd,
                        2
                      )
                    }}
                    USD
                  </span>
                  <span v-else>
                    {{ rateInternal.message }}
                    <el-button
                      v-if="hasAtleastOneAmount"
                      type="text"
                      @click="openManualPrompt('diffAmountManual')()"
                      >Установить разницу вручную</el-button
                    >
                  </span>
                </el-form-item>
                <el-form-item
                  label-width="170px"
                  label="Разница %"
                  size="normal"
                >
                  <span v-if="rateInternal.status">
                    {{
                      Math.round(
                        // ((1 - rate.outinRate / rateInternal.outinRate) * 100 +
                        (((rateInternal.outinRate - rate.outinRate) /
                          rate.outinRate) *
                          100 +
                          Number.EPSILON) *
                          100
                      ) / 100
                    }}%
                  </span>
                  <span v-else>
                    {{ rateInternal.message }}
                    <el-button
                      v-if="hasAtleastOneAmount"
                      type="text"
                      @click="openManualPrompt('diffPercentManual')()"
                      >Установить разницу вручную</el-button
                    >
                  </span>
                </el-form-item>
              </div>
            </el-form-item>

            <el-card
              v-for="(transaction, index) in form.transactions"
              :key="index"
              shadow="always"
              :body-style="{ padding: '20px' }"
            >
              <div slot="header">
                <span>Транзакция {{ index + 1 }}</span>
                <el-tooltip
                  :content="
                    transaction.createdAt
                      ? `Транзакция создана ${$dayjs(
                          transaction.createdAt
                        ).format('DD.MM.YYYY HH:mm:ss')}`
                      : `Дата создания транзакции неизвестна`
                  "
                  placement="top"
                  effect="light"
                >
                  <span class="transaction-date transaction-date-created"
                    ><i class="el-icon-document-add"></i
                    >{{
                      transaction.createdAt
                        ? $dayjs(transaction.createdAt).format(
                            "DD.MM.YYYY HH:mm:ss"
                          )
                        : "N/A"
                    }}</span
                  >
                </el-tooltip>
                <el-tooltip
                  :content="
                    transaction.updatedAt
                      ? `Транзакция изменена ${$dayjs(
                          transaction.updatedAt
                        ).format('DD.MM.YYYY HH:mm:ss')}`
                      : `Дата изменения транзакции неизвестна`
                  "
                  placement="top"
                  effect="light"
                >
                  <span class="transaction-date transaction-date-updated"
                    ><i class="el-icon-edit"></i
                    >{{
                      transaction.updatedAt
                        ? $dayjs(transaction.updatedAt).format(
                            "DD.MM.YYYY HH:mm:ss"
                          )
                        : "N/A"
                    }}</span
                  ></el-tooltip
                >
                <el-tooltip
                  v-if="
                    !isClosed && !transaction.counted && !transaction.deleted
                  "
                  placement="top"
                >
                  <div slot="content">Удалить транзакцию</div>
                  <el-button
                    type="danger"
                    style="float: right; padding: 3px 3px"
                    icon="el-icon-delete"
                    @click="onRemoveTransaction(index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    !isClosed && transaction.counted
                    // && session.type <= -1
                  "
                  placement="top"
                >
                  <div slot="content">
                    Разблокировать транзакцию для редактирования
                  </div>
                  <el-button
                    type="primary"
                    style="float: right; padding: 3px 3px"
                    icon="el-icon-unlock"
                    @click="onUncountTransaction(index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    !isClosed && transaction.deleted
                    // && session.type <= -1
                  "
                  placement="top"
                >
                  <div slot="content">
                    Отменить удаление
                  </div>
                  <el-button
                    type="success"
                    style="float: right; padding: 3px 3px"
                    icon="el-icon-refresh-left"
                    @click="onRestoreTransaction(index)"
                  ></el-button>
                </el-tooltip>
              </div>
              <div class="trbody">
                <div class="trmain">
                  <el-form-item
                    label="Вид"
                    :prop="'transactions.' + index + '.direction'"
                    :rules="
                      transaction.deleted ? [] : validation.direction.rules
                    "
                  >
                    <el-radio-group
                      v-model="form.transactions[index].direction"
                      @change="onDirectionChange(index)"
                      :disabled="transaction.counted"
                    >
                      <el-radio label="in">Входящая</el-radio>
                      <el-radio label="out">Исходящая</el-radio>
                      <el-radio label="deposit_out" :disabled="!form.isDeposit"
                        >Депозит</el-radio
                      >
                      <el-radio label="deposit_in" :disabled="!form.isDeposit"
                        >Возврат депозита</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    label="Заморожена?"
                    :prop="'transactions.' + index + '.suspended'"
                    :rules="validation.suspended.rules"
                    v-if="['out', 'in'].includes(transaction.direction)"
                  >
                    <el-switch
                      :disabled="transaction.counted"
                      v-model="form.transactions[index].suspended"
                    >
                    </el-switch>
                  </el-form-item>
                  <el-form-item
                    v-if="
                      isDepositOut(index) &&
                        (!balanceAccountsOptions({ transaction, index })
                          .length)
                    "
                    label="Валюта"
                    :prop="'transactions.' + index + '.valute'"
                    :rules="transaction.deleted ? [] : validation.valute.rules"
                  >
                    <el-select
                      v-model="form.transactions[index].valute"
                      filterable
                      :loading="!valutes.length"
                      :disabled="transaction.counted"
                    >
                      <el-option
                        v-for="item in valutesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="Баланс"
                    v-if="
                      isDepositOut(index) &&
                        (!balanceAccountsOptions({ transaction, index })
                          .length)
                    "
                  >
                    <div>
                      Для транзакции вида "Депозит" баланс будет создан при
                      сохранении обмена. Пожалуйста заполните эту транзакцию и
                      нажмите "<span>Создать операцию</span> и зафиксировать
                      депозит".
                    </div>
                  </el-form-item>
                  <el-form-item
                    v-else
                    label="Баланс"
                    :prop="'transactions.' + index + '.balanceAccount'"
                    :rules="
                      transaction.deleted ? [] : validation.balanceAccount.rules
                    "
                  >
                    <el-select
                      v-model="form.transactions[index].balanceAccount"
                      filterable
                      :loading="
                        !allBalanceAccounts.docs ||
                          !allBalanceAccounts.docs.length
                      "
                      :disabled="transaction.counted"
                      @change="handleBalanceAccountChange(index, $event)"
                    >
                      <!-- || isDepositOut(index) -->
                      <el-option
                        v-for="item in balanceAccountsOptions({
                          transaction,
                          index
                        })"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="Сумма"
                    :prop="'transactions.' + index + '.amount'"
                    :rules="transaction.deleted ? [] : validation.amount.rules"
                  >
                    <el-input
                      v-model="form.transactions[index].amount"
                      :disabled="transaction.counted"
                      @change="handleAmountChange(index, $event)"
                    >
                      <i
                        v-if="isMinus(index)"
                        slot="prefix"
                        class="el-input__icon el-icon-minus"
                      ></i>
                      <i
                        v-else
                        slot="prefix"
                        class="el-input__icon el-icon-plus"
                      ></i>
                      <template
                        v-if="
                          getValuteNameFromBalanceAccountId(
                            form.transactions[index].balanceAccount
                          )
                        "
                        slot="suffix"
                        >{{
                          getValuteNameFromBalanceAccountId(
                            form.transactions[index].balanceAccount
                          )
                        }}</template
                      >
                    </el-input>
                  </el-form-item>
                  <el-card
                    shadow="always"
                    :body-style="{ padding: '20px' }"
                    v-if="isInOrOut(index)"
                  >
                    <el-form-item
                      label="Комиссия?"
                      :prop="'transactions.' + index + '.hasComission'"
                    >
                      <el-switch
                        :disabled="transaction.counted"
                        v-model="form.transactions[index].hasComission"
                      >
                      </el-switch>
                    </el-form-item>
                    <el-form-item
                      label="Сумма"
                      :prop="'transactions.' + index + '.comissionAmount'"
                      v-if="hasComission(index)"
                    >
                      <el-input-number
                        :disabled="transaction.counted"
                        v-model="form.transactions[index].comissionAmount"
                        :min="0"
                        @change="handleComissionAmountChange(index, $event)"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      label="Процент"
                      :prop="
                        'transactions.' + index + '.comissionAmountPercent'
                      "
                      v-if="hasComission(index)"
                    >
                      <el-input-number
                        :disabled="transaction.counted"
                        v-model="
                          form.transactions[index].comissionAmountPercent
                        "
                        :min="0"
                        :precision="4"
                        :step="0.1"
                        @change="
                          handleComissionAmountPercentChange(index, $event)
                        "
                      ></el-input-number>
                    </el-form-item>
                  </el-card>
                </div>
                <div v-if="transaction.deleted" class="troverlay">
                  <div>
                    Будет удалена!
                  </div>
                </div>
              </div>
            </el-card>
            <el-card shadow="always" :body-style="{ padding: '20px' }">
              <el-form-item v-if="showBottomButtons">
                <el-button
                  type="primary"
                  @click="onAddTransaction"
                  :disabled="
                    (hasDepositTransaction) ||
                      isClosed ||
                      form.isCorrection ||
                      form.isOpex
                  "
                  >Добавить транзакцию</el-button
                >
              </el-form-item>
              <el-form-item v-if="showBottomButtons">
                <template>
                  <el-button
                    v-if="isClosed || form.isCorrection || form.isOpex"
                    disabled="disabled"
                    type="primary"
                  >{{
                      hasDepositTransaction
                        ? "Создать операцию и зафиксировать депозит"
                        : "Создать операцию"
                    }}</el-button
                  >
                  <el-popconfirm
                    v-else
                    title="Сделка будет создана. Ее все еще можно редактировать"
                    @confirm="onSubmit(false)"
                  >
                    <el-button slot="reference" type="primary">{{
                        hasDepositTransaction
                          ? "Создать операцию и зафиксировать депозит"
                          : "Создать операцию"
                      }}</el-button>
                  </el-popconfirm>
                  <el-button
                    v-if="
                      // !hasOutTransaction ||
                      hasSuspendedTransaction &&
                        !form.isCorrection &&
                        !form.isOpex
                    "
                    disabled="disabled"
                    type="primary"
                  >Создать и закрыть операцию</el-button
                  >
                  <el-popconfirm
                    v-else
                    title="Сделка будет закрыта. Дальнейшие изменения возможны только с доступом суперадмина"
                    @confirm="onSubmit(true)"
                  >
                    <el-button slot="reference" type="primary"
                    >Создать и закрыть операцию</el-button
                    >
                  </el-popconfirm>
                </template>
                <el-button @click="$router.push({ name: 'Ledger' })"
                  >Отмена</el-button
                >
              </el-form-item>
            </el-card>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {
  getBalanceAccounts,
  getUsersSuggest,
  getLedgerValutes,
  getBinanceRate,
  getTransactionById
} from "@/api";

import exchangeTemplates from "./exchangeTemplates";
import sources from "./sources";
import validation from "./validation";
import fees from "./fees";
import categories from "./categories";
import {addLedgerExchange} from "../../../api";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "LedgerAdd",
  data: () => ({
    form: {
      dateStart: new Date(),
      dateEnd: null,
      userName: "",
      isDeposit: false,
      isCorrection: false,
      isOpex: false,
      isInternal: false,
      comment: "",
      level: 1,
      sourceType: "",
      sourceChannel: "",
      transactions: []
    },
    userSuggestions: [],
    transactionTemplate: {
      valute: "",
      amount: 0,
      direction: "in",
      balanceAccount: "",
      counted: false,
      hasComission: false,
      suspended: false
    },
    allBalanceAccounts: {},
    loading: true,
    loaded: false,
    isClosed: false,
    showBottomButtons: false,
    exchangeTemplates,
    sources,
    ledgerValutes: [],
    rate: {},
    rateLoading: false,
    transaction: {},
    validation,
    fees,
    categories
  }),
  computed: {
    ...mapState("valutes", ["valutes"]),
    ...mapState("auth", ["session"]),
    valutesOptions() {
      return this.ledgerValutes.map(valute => {
        return {
          value: valute._id,
          label: valute.name
        };
      });
    },
    balanceAccountsOptions() {
      return (t = {}) => {
        if (!this.allBalanceAccounts.docs) return [];
        return this.allBalanceAccounts.docs
          .map(balanceAccount => {
            return {
              value: balanceAccount._id,
              label: `${balanceAccount.title} - ${balanceAccount.balance} ${
                balanceAccount.valute ? balanceAccount.valute.name : ""
              }`
            };
          })
          .filter(option => {
            return (
              (t.transaction.direction !== "deposit_out" &&
                t.transaction.direction !== "deposit_in") ||
              this.form.transactions.find(
                tr =>
                  tr.balanceAccount === option.value &&
                  tr.direction === "deposit_out"
              )
            );
          });
      };
    },
    hasDepositTransaction() {
      return (
        this.form.transactions.findIndex(
          transaction => transaction.direction === "deposit_out"
        ) !== -1
      );
    },
    hasUncountedDepositTransaction() {
      return (
        this.form.transactions.findIndex(
          transaction =>
            transaction.direction === "deposit_out" && !transaction.counted
        ) !== -1
      );
    },
    hasOutTransaction() {
      return (
        this.form.transactions.findIndex(transaction =>
          ["deposit_in", "out"].includes(transaction.direction)
        ) !== -1
      );
    },
    hasSuspendedTransaction() {
      return (
        this.form.transactions.findIndex(
          transaction => transaction.suspended
        ) !== -1
      );
    },
    canGetRate() {
      const intrans = this.form.transactions.find(tr => tr.direction === "in");
      if (!intrans)
        return {
          status: false,
          message: `Нет входящих транзакций!`
        };

      const incode = this.getValuteNameFromBalanceAccountId(
        intrans.balanceAccount
      );
      if (!incode)
        return {
          status: false,
          message: `Во входящей транзакции не выбран баланс либо баланс без валюты!`
        };

      const outtrans = this.form.transactions.find(
        tr => tr.direction === "out"
      );
      if (!outtrans)
        return {
          status: false,
          message: `Нет исходящих транзакций!`
        };

      const outcode = this.getValuteNameFromBalanceAccountId(
        outtrans.balanceAccount
      );
      if (!outcode)
        return {
          status: false,
          message: `В исходящей транзакции не выбран баланс либо баланс без валюты!`
        };

      return { status: true, incode, outcode };
    },
    rateInternal() {
      this.form.rateInternal = undefined;
      const intrans = this.form.transactions.find(tr => tr.direction === "in");
      const inamount = intrans.amount * 1;
      if (!inamount)
        return {
          status: false,
          message: `Во входящей транзакции не введена сумма!`
        };

      const outtrans = this.form.transactions.find(
        tr => tr.direction === "out"
      );
      const outamount = outtrans.amount * 1;
      if (!outamount)
        return {
          status: false,
          message: `В исходящей транзакции не введена сумма!`
        };

      this.form.rateInternal = inamount / outamount;
      return {
        status: true,
        inamount,
        outamount,
        outinRate: inamount / outamount,
        inoutRate: outamount / inamount
      };
    },
    hasAtleastOneAmount() {
      this.form.rateInternal = undefined;
      const intrans = this.form.transactions.find(tr => tr.direction === "in");
      const inamount = intrans.amount * 1;

      const outtrans = this.form.transactions.find(
        tr => tr.direction === "out"
      );
      const outamount = outtrans.amount * 1;
      return !!inamount || !!outamount;
    }
  },
  watch: {
    async canGetRate(curr, prev) {
      if (curr.status) {
        await this.getRate();
      }
    }
  },
  methods: {
    ...mapActions("ledgerExchanges", ["addLedgerExchange"]),
    ...mapActions("valutes", ["getValutes", "getSortedValutes"]),
    getStatusText(status) {
      switch (+status) {
        case 0:
          return "В ожидании средств";
        case 1:
          return "В обработке";
        case 2:
          return "Подтверждено";
        case 3:
          return "Отклонено";
        case 4:
          return "Отменено";
        case 5:
          return "В ожидании фото для верификации";
        case 6:
          return "Верификация";
        case 106:
          return "Возобновлен";
      }
    },
    getStatusCss(status) {
      switch (+status) {
        case 0:
        case 1:
          return { orange: true };
        case 2:
        case 106:
          return { green: true };
        case 3:
        case 4:
          return { red: true };
      }
    },
    openManualPrompt(param) {
      const that = this;
      const opts = {
        rateInternalManual: {
          message: `Введите желаемый курс сделки в ${this.rate.incode} за 1 ${this.rate.outcode}`,
          title: "Ручной ввод",
          inputValidator: val =>
            Number.isFinite(val * 1) ? true : "Введите число!"
        },
        diffAmountManual: {
          message: `Введите желаемую монетарную разницу в ${this.rate.outcode}`,
          title: "Ручной ввод",
          inputValidator: val =>
            Number.isFinite(val * 1) ? true : "Введите число!"
        },
        diffPercentManual: {
          message: `Введите желаемую разницу в %`,
          title: "Ручной ввод",
          inputValidator: val =>
            Number.isFinite(val * 1) ? true : "Введите число!"
        }
      };
      return () => {
        that
          .$prompt(opts[param].message, opts[param].title, {
            confirmButtonText: "OK",
            cancelButtonText: "Отмена",
            inputValidator: opts[param].inputValidator
          })
          .then(({ value }) => {
            const mess = that.setManualValue(param)(value * 1);
            that.$message({
              type: "success",
              message: mess
            });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "Ввод отменен"
            });
          });
      };
    },
    setManualValue(param) {
      const that = this;
      return val => {
        const intrans = that.form.transactions.find(
          tr => tr.direction === "in"
        );
        const inamount = intrans.amount * 1;
        const outtrans = that.form.transactions.find(
          tr => tr.direction === "out"
        );
        const outamount = outtrans.amount * 1;

        if (!inamount) {
          if (param === "rateInternalManual") intrans.amount = outamount * val;
          if (param === "diffAmountManual")
            intrans.amount = (val + outamount) / (1 / that.rate.outinRate);
          if (param === "diffPercentManual")
            intrans.amount =
              ((1 + val / 100) * outamount) / (1 / that.rate.outinRate);
          return "Сумма во входящей транзакции обновлена";
        }

        if (!outamount) {
          if (param === "rateInternalManual") outtrans.amount = inamount / val;
          if (param === "diffAmountManual")
            outtrans.amount = inamount / that.rate.outinRate - val;
          if (param === "diffPercentManual")
            outtrans.amount = inamount / that.rate.outinRate / (1 + val / 100);
          return "Сумма в исходящей транзакции обновлена";
        }
      };
    },
    getValuteNameFromBalanceAccountId(id) {
      if (!id || !this.allBalanceAccounts.docs) return null;
      const ba = this.allBalanceAccounts.docs.find(b => b._id === id);
      if (!ba) return null;
      return ba.valute && ba.valute.name;
    },
    async getRate() {
      this.rate = {};
      this.form.rateFromExchanges = undefined;
      if (!this.canGetRate.status)
        return this.$message({
          type: "error",
          message: this.canGetRate.message
        });
      try {
        this.rateLoading = true;
        const { data } = await getBinanceRate(
          this.canGetRate.incode,
          this.canGetRate.outcode
        );
        this.rate = {
          ...data.result,
          rateDate: new Date()
        };
        this.form.rateFromExchanges = { ...this.rate };
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      } finally {
        this.rateLoading = false;
      }
    },
    isDepositOut(index) {
      return this.form.transactions[index].direction === "deposit_out";
    },
    isInOrOut(index) {
      return (
        this.form.transactions[index].direction === "out" ||
        this.form.transactions[index].direction === "in"
      );
    },
    hasComission(index) {
      return this.form.transactions[index].hasComission;
    },
    isMinus(index) {
      return ["deposit_out", "out"].includes(
        this.form.transactions[index].direction
      );
    },
    // *************************************
    handleComissionAmountChange(index, val) {
      this.form.transactions[index].comissionAmountPercent = !!+this.form
        .transactions[index].amount
        ? (+val / +this.form.transactions[index].amount) * 100
        : 0;
    },
    handleComissionAmountPercentChange(index, val) {
      this.form.transactions[index].comissionAmount =
        (+val / 100) * +this.form.transactions[index].amount;
    },
    handleAmountChange(index, val) {
      if (!this.form.transactions[index].hasComission) return;
      if (!+val) {
        this.form.transactions[index].comissionAmountPercent = 0;
        return;
      }
      if (this.form.transactions[index].comissionAmount) {
        this.form.transactions[index].comissionAmountPercent =
          (this.form.transactions[index].comissionAmount / +val) * 100;
        return;
      }
      if (this.form.transactions[index].comissionAmountPercent) {
        this.form.transactions[index].comissionAmount =
          (+this.form.transactions[index].comissionAmountPercent / 100) * +val;
      }
    },
    handleBalanceAccountChange(index, val) {
      const bafull = this.allBalanceAccounts.docs.find(ba => ba._id === val);
      if (!bafull) return;
      const fee =
        bafull.valute && bafull.valute.name
          ? this.fees.find(
              f => f.name.toLowerCase() === bafull.valute.name.toLowerCase()
            )
          : null;
      if (!fee) return;
      const balanceFee = bafull.type ? fee[bafull.type] : null;
      if (!balanceFee) return;
      const directionFee = this.form.transactions[index].direction
        ? balanceFee[this.form.transactions[index].direction]
        : null;
      if (!directionFee) return;
      this.form.transactions[index].hasComission = true;
      if (directionFee.comissionAmount) {
        this.form.transactions[index].comissionAmount =
          directionFee.comissionAmount;
        // this.handleComissionAmountChange(index, directionFee.comissionAmount);
        return;
      }
      if (directionFee.comissionAmountPercent) {
        this.form.transactions[index].comissionAmountPercent =
          directionFee.comissionAmountPercent;
        return;
      }
    },
    // **********************************
    async onSubmit(isClosed = false) {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          if (isClosed) this.form.dateEnd = new Date();
          if (!this.session._id) return alert("Ошибка определения оператора!");
          const data = {
            ...this.form,
            ledgerTransactions: this.form.transactions,
            transactionId: this.$route.params.transactionId,
            creator: this.session._id
          };
          try {
            this.loading = true;
            const resp = await this.addLedgerExchange(data);
            if (!resp.status || !resp.result._id)
              throw new Error("Что-то пошло не так!");
            this.$confirm(
              `Операция прошла успешно, вернуться к списку?`,
              "Успех",
              {
                confirmButtonText: "Вернуться",
                cancelButtonText: "Остаться",
                type: "success"
              }
            )
              .then(() => {
                this.$router.push({ name: "Ledger" });
              })
              .catch(async () => {
                await this.$router.push({
                  name: "LedgerEdit",
                  params: {id: resp.result._id}
                });
              });
          } catch (error) {
            this.$message({ type: "error", message: "Что-то пошло не так!" });
          } finally {
            this.loading = false;
          }
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
          return false;
        }
      });
    },
    clearFieldsValidation(fields) {
      this.$refs["form"].clearValidate(fields);
    },
    onAddTransaction() {
      this.form.transactions = [
        ...this.form.transactions,
        { ...this.transactionTemplate }
      ];
    },
    onRemoveTransaction(index) {
      this.form.transactions = this.form.transactions
        .map((transaction, i) => {
          return i !== index
            ? { ...transaction }
            : transaction.edited
            ? { ...transaction, counted: false, deleted: true }
            : { ...transaction };
        })
        .filter((transaction, i) => {
          return i !== index || transaction.edited;
        });
      this.$refs["form"].clearValidate();
    },
    onRestoreTransaction(index) {
      this.form.transactions = this.form.transactions.map((transaction, i) => {
        return i !== index
          ? { ...transaction }
          : transaction.deleted
          ? { ...transaction, counted: false, deleted: false }
          : { ...transaction };
      });
    },
    onUncountTransaction(index) {
      this.form.transactions = this.form.transactions.map((transaction, i) => {
        return i !== index
          ? { ...transaction }
          : { ...transaction, counted: false, edited: true };
      });
    },
    onDirectionChange(index) {
      this.clearFieldsValidation([
        "transactions." + index + ".direction",
        "transactions." + index + ".valute",
        "transactions." + index + ".balanceAccount",
        "transactions." + index + ".amount"
      ]);
    },
    async onMount() {
      const template = this.exchangeTemplates.find(
        template => template.type === 'add-transaction'
      );

      this.form.transactions = template.template.transactions.map(entry => {
        return { ...entry };
      });
      this.form.isDeposit = template.template.isDeposit;
      this.form.isCorrection = template.template.isCorrection;
      this.form.isOpex = template.template.isOpex;
      this.form.isInternal = template.template.isInternal;
      this.form.level = template.template.level;
      this.showBottomButtons = true;

      if (typeof this.$refs["form"] !== 'undefined') {
        this.$refs["form"].clearValidate();
      }

      const transactionResp = await getTransactionById(this.$route.params.transactionId);
      if (transactionResp.data.status) {
        const transaction = transactionResp.data.result;
        this.transaction = transaction;
        this.form.userName = transaction._id;
        switch (transaction.trans.source) {
          case 'api':
            this.form.sourceType = 'api';
            this.form.sourceChannel = 'catbit';
            break;
          case 'stylebtc':
            this.form.sourceType = 'site';
            this.form.sourceChannel = 'stylebtc';
            break;
          case 'catbit':
          default:
            this.form.sourceType = 'site';
            this.form.sourceChannel = 'catbit';
        }
      }
      const resp = await getBalanceAccounts({ pagination: false });
      if (resp.data.status) this.allBalanceAccounts = resp.data.result;
      const valutesResp = await getLedgerValutes({ pagination: false });
      if (valutesResp.data.status)
        this.ledgerValutes = valutesResp.data.result.docs;
      this.loading = false;
    }
  },
  beforeMount() {},
  async mounted() {
    await this.onMount();
    this.loaded = true;
  }
};
</script>
<style scoped>
.block {
  border-radius: 4px;
  border: 1px solid #EBEEF5;
  margin-bottom: 22px;
}
.block > .header > .title {
  font-size: 14px;
}
.block > .content {
  font-size: 12px;
}
.green {
  border-left: 5px solid green;
}
.orange {
  border-left: 5px solid orange;
}
.red {
  border-left: 5px solid red;
}
.content {
  overflow: hidden;
}
.block-left,
.block-right {
  float: left;
  padding: 0 5px 10px 5px;
  width: calc(50% - 11px);
}
.block-left {
  border-right: 1px solid #d9d9d9;
}
.trbody {
  position: relative;
  /* width: 100%; */
  /* height: 100%; */
}
.trbody .trmain {
  /* position: absolute; */
}
.trbody .troverlay {
  position: absolute;
  background-color: rgba(245, 108, 108, 0.7);
  width: 100%;
  height: 100%;
  z-index: 2;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trbody .troverlay div {
  font-size: 2rem;
  color: #fff;
}
.transaction-date {
  color: #aaa;
  margin-left: 1rem;
  font-size: 0.85rem;
}
.transaction-date i {
  margin-right: 5px;
  color: hsl(210, 50%, 63%);
}
.el-card:not(:last-child) {
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/addTransaction.vue